import { Roles } from '@/app/core/auth/role'
import { SessionService } from '@/app/core/services/session.service'
import { Component } from '@angular/core'
import { Router } from '@angular/router'

@Component({
  selector: 'app-access-denied',
  templateUrl: './access-denied.component.html',
  styleUrls: ['./access-denied.component.scss'],
})
export class AccessDeniedComponent {
  constructor(
    private router: Router,
    private sessionService: SessionService
  ) {}

  goBack(): void {
    const isLoggedIn = this.sessionService.isLoggedIn()

    if (isLoggedIn) {
      const role = this.sessionService.getUserRole()

      if (role === Roles.MERCHANT) {
        this.router.navigate(['/user/dashboard'])
      } else if (role === Roles.SYSTEM_ADMIN) {
        this.router.navigate(['/system-admin/dashboard'])
      } else {
        this.router.navigate(['/auth/sign-in'])
      }
    } else {
      this.router.navigate(['/auth/sign-in'])
    }
  }
}
